import { Button } from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)<{ $active: boolean }>`
    svg {
        color: ${({ theme, $active }) =>
            $active ? theme.colors.green : theme.primaryTypographyColor};
    }
`;
